import { w3cwebsocket } from "websocket";
import { Action } from './actions';

export class JustoneClient {
    private w3cwebsocket: w3cwebsocket;
    private static instance: JustoneClient | undefined;

    private constructor(public name: string, public gid: string = "") {
        this.w3cwebsocket = this.initWebsocket();
    }

    static getInstance(name?: string, gid?: string): JustoneClient {
        if (!name) return JustoneClient.instance!;
        if (!JustoneClient.instance) JustoneClient.instance = new JustoneClient(name, gid);
        return this.instance!;
    }

    private initWebsocket() {
        const client = new w3cwebsocket(`${process.env.VUE_APP_GAME_SERVER_URL}/justone?name=${this.name}&gid=${this.gid}`);

        client.onerror = () => {
            console.log('Connection Error');
        };

        client.onopen = () => {
            console.log('WebSocket Client Connected');
            this.onopen();
        };

        client.onclose = (e) => {
            console.log('WebSocket Client closed: ' + e.reason);
            this.onclose(e.reason);
        };

        client.onmessage = e => {
            if (typeof e.data === 'string') {
                console.log(JSON.parse(e.data));
                this.onmessage(JSON.parse(e.data));
            }
        };

        (window as any).client = client;
        return client;
    }

    onopen: () => void = () => { }
    onclose: (reason: string) => void = () => { }

    onmessage: (payload: IAction) => void = () => { }

    send<T extends IAction>(payload: T) {
        this.w3cwebsocket.send(JSON.stringify(payload));
    }
}

interface IAction {
    action: Action
}



